import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";

const DeleterecipesSubrecipes = () => {
    const API_URL = process.env.REACT_APP_API_URL;
  const [recipes, setRecipes] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const navigate = useNavigate();


//   const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
//   const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const [selectedRecipe, setSelectedRecipe] = useState(null);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    fetchRecipes();
  }, []);

  const fetchRecipes = async () => {
    try {
      const response = await fetch(`${API_URL}/recipe/getall`); // Replace with your backend endpoint
      const data = await response.json();
      setRecipes(data.results);
    } catch (error) {
      console.error("Error fetching recipes:", error);
    }
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

 

  const handleOpenEditDialog = (recipe) => {
    // Optional: if you want to store recipe data before navigating
//   setSelectedRecipe(recipe);
//   setFormData({ ...recipe });

  // Navigate to /home instead of opening the dialog
  navigate(`/updaterecipesubrecipe/${recipe.title_id}`);
    setSelectedRecipe(recipe);
    setFormData({ ...recipe });
    // setOpenEditDialog(true);
  };

  const handleOpenDeleteDialog = (recipe) => {
    setSelectedRecipe(recipe);
    setOpenDeleteDialog(true);
  };

  const handleCloseDialogs = () => {
    // setOpenDetailsDialog(false);
    // setOpenEditDialog(false);
    setOpenDeleteDialog(false);
    setSelectedRecipe(null);
    setFormData({});
  };

  const handleEditSubmit = async () => {
    try {
      const response = await fetch(`/api/recipes/${selectedRecipe.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error("Failed to update recipe");
      }

      const updatedRecipe = await response.json();
      setRecipes((prev) =>
        prev.map((recipe) =>
          recipe.id === updatedRecipe.id ? updatedRecipe : recipe
        )
      );
      console.log("Recipe updated:", updatedRecipe);
    } catch (error) {
      console.error("Error updating recipe:", error);
    } finally {
      handleCloseDialogs();
    }
  };

  const handleDeleteSubmit = async () => {
    try {
    const response = await fetch(`${API_URL}/recipe/delete-recipes-subrecipes/${selectedRecipe.title_id}`, {
        method: "DELETE",
      });

      if (!response.ok) {
        throw new Error("Failed to delete recipe");
      }

      setRecipes((prev) =>
        prev.filter((recipe) => recipe.title_id !== selectedRecipe.title_id)
      );
      console.log("Recipe deleted:", selectedRecipe);
    } catch (error) {
      console.error("Error deleting recipe:", error);
    } finally {
      handleCloseDialogs();
    }
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Recipes</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {recipes
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((recipe) => (
                <TableRow key={recipe.title_id}>
                  <TableCell>{recipe.title_id}</TableCell>
                  <TableCell>{recipe.title_name}</TableCell>
                  <TableCell sx={{ width: "50%" }}>
                    {recipe.short_description}
                  </TableCell>
                  <TableCell
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      //   justifyContent: "space-evenly",
                      gap: 4,
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={() => handleOpenEditDialog(recipe)}
                      sx={{ marginRight: 1 }}
                    >
                      Edit
                    </Button>
                    <Button
                      variant="contained"
                      color="error"
                      size="small"
                      onClick={() => handleOpenDeleteDialog(recipe)}
                      sx={{ marginRight: 1 }}
                    >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={recipes.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      </TableContainer>
    

      {/* See Details Dialog */}
      {/* <Dialog open={openDetailsDialog} onClose={handleCloseDialogs}>
        <DialogTitle>Recipe Details</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            <b>Title ID:</b> {selectedRecipe?.title_id}
          </Typography>
          <Typography variant="body1">
            <b>Author ID:</b> {selectedRecipe?.user_id}
          </Typography>
          <Typography variant="body1">
            <b>Category ID:</b> {selectedRecipe?.category_id}
          </Typography>
          <Typography variant="body1">
            <b>Author name:</b> {selectedRecipe?.author_name}
          </Typography>
       
          <Typography variant="body1">
            <b>Category name:</b> {selectedRecipe?.category_name}
          </Typography>
          <Typography variant="body1">
            <b>mealType name:</b> {selectedRecipe?.mealType_name}
          </Typography>
          <Typography variant="body1">
            <b>Title name:</b> {selectedRecipe?.title_name}
          </Typography>
          <Typography variant="body1">
            <b>Post name:</b> {selectedRecipe?.post_name}
          </Typography>
          <Typography variant="body1">
            <b>Total rating:</b> {selectedRecipe?.totalrating}
          </Typography>
          <Typography variant="body1">
            <b>Total review message:</b> {selectedRecipe?.totalreviewrecipe_message}
          </Typography>
          <Typography variant="body1">
            <b>Image url:</b> {selectedRecipe?.url}
          </Typography>
          <Typography variant="body1">
            <b>Short Description:</b> {selectedRecipe?.short_description}
          </Typography>
          <Typography variant="body1">
            <b>Is featured?:</b> {selectedRecipe?.is_featured}
          </Typography>
          <Typography variant="body1">
            <b>Difficulty level:</b> {selectedRecipe?.difficulty_level}
          </Typography>
          <Typography variant="body1">
            <b>Cuisine:</b> {selectedRecipe?.cuisine}
          </Typography>
         
          <Typography variant="body1">
            <b>Dietary info:</b> {selectedRecipe?.dietary_info}
          </Typography>
          
          <Typography variant="body1">
            <b>Views:</b> {selectedRecipe?.views}
          </Typography>
          <Typography variant="body1">
            <b>Likes:</b> {selectedRecipe?.likes}
          </Typography>
       
          <Typography variant="body1">
            <b>Tags:</b> {selectedRecipe?.tags}
          </Typography>
          <Typography variant="body1">
            <b>Created at:</b> {selectedRecipe?.created_at}
          </Typography>
          <Typography variant="body1">
            <b>Updated at:</b> {selectedRecipe?.updated_at}
          </Typography>
         
         
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogs} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog> */}

      {/* Edit Dialog */}
      {/* <Dialog open={openEditDialog} onClose={handleCloseDialogs}>
        <DialogTitle>Edit Recipe</DialogTitle>
        <DialogContent>
          <TextField
            label="Title ID"
            name="title_id"
            value={formData.title_id || ""}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
          <TextField
            label="Author ID"
            name="user_id"
            value={formData.user_id || ""}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
           <TextField
            label="Category ID"
            name="category_id"
            value={formData.category_id || ""}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
          <TextField
            label="Author name"
            name="author_name"
            value={formData.author_name || ""}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
           <TextField
            label="Category name"
            name="category_name"
            value={formData.category_name || ""}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
          <TextField
            label="mealType name"
            name="mealType_name"
            value={formData.mealType_name || ""}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
           <TextField
            label="Name"
            name="title_name"
            value={formData.title_name || ""}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
          <TextField
            label="Post name"
            name="post_name"
            value={formData.post_name || ""}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
           <TextField
            label="Name"
            name="title_name"
            value={formData.title_name || ""}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
          <TextField
            label="Total rating"
            name="totalrating"
            value={formData.totalrating || ""}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
           <TextField
            label="Total review message"
            name="totalreviewrecipe_message"
            value={formData.totalreviewrecipe_message || ""}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
          <TextField
            label="Image url"
            name="url"
            value={formData.url || ""}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
           <TextField
            label="Short description"
            name="short_description"
            value={formData.short_description || ""}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
          <TextField
            label="Is featured"
            name="is_featured"
            value={formData.is_featured || ""}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
           <TextField
            label="Difficulty level"
            name="difficulty_level"
            value={formData.difficulty_level || ""}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
          <TextField
            label="Cuisine"
            name="cuisine"
            value={formData.cuisine || ""}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
           <TextField
            label="Dietary info"
            name="dietary_info"
            value={formData.dietary_info || ""}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
          <TextField
            label="Views"
            name="views"
            value={formData.views || ""}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
           <TextField
            label="Likes"
            name="likes"
            value={formData.likes || ""}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
          <TextField
            label="Tags"
            name="tags"
            value={formData.tags || ""}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
           <TextField
            label="Created at"
            name="created_at"
            value={formData.created_at || ""}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
           <TextField
            label="Updated at"
            name="updated_at"
            value={formData.updated_at || ""}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogs} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleEditSubmit} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog> */}

      {/* Delete Dialog */}
      <Dialog open={openDeleteDialog} onClose={handleCloseDialogs}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          Are you sure you want to delete the recipe{" "}
          <b>{selectedRecipe?.title_name}</b>?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogs} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleDeleteSubmit} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleterecipesSubrecipes;